


















































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import info from "@/info";
import ModelSelector from "@/components/modelSelector.vue";

@Component({
  name: "vesionsCarsCards",
  components: {
      ModelSelector
  }
})
export default class VesionsCarsCards extends Vue {
  public expanded: boolean = true;
  public modelInfo: object = {};

  public selectedYear: string = '';
  public indexYear: number = 0;
  public selectedModel: string = '';
  public indexModel: number = 0;
  public selectedColor: string = '';
  public indexColor: number = 0;
  public selectedTransmision: number = 0;
  public indexTransmision: number = 0

  scrollState(state: string) {
      const elem = document.getElementById("scrollBlock");
      elem!.style.overflow = state;
  }

  openMenuForm21M(): void {
      let curtainForm = document.getElementById("curtain-formM");
      let menuForm = document.getElementById("menu-formM");

      if (curtainForm) {
      curtainForm.style.display = "block";
      }
      menuForm?.classList.remove("disable-menu-formM");
      menuForm?.classList.add("open-menu-formM");
  }
  

  @Prop() model  ?: string

  

  mounted() {
      for (let i in info.home.headerSlider) {
          if (info.home.headerSlider[i].name === this.model) {
          this.modelInfo = info.home.headerSlider[i];
          }
      }
  }
  checkAñoCards(btnID: string, i: number) {
      this.selectedYear = btnID;
      this.indexYear = i;
    }
  checkTransmision(btnID: string, i: number, iC: number) {
      this.indexTransmision = i;
  }
  
}

